import backArrow from '../../assets/img/backArrow.png';

const BarCodeScanSuccess = ({ scanNewAppointmentId }) => {
  return (
    <form className="location-form">
      <div className="row">
        <div className="col-lg-12">
          <h4 className="pageTitle">
            {' '}
            <span
              className="pageTitle backArrow"
              onClick={scanNewAppointmentId}
            >
              <img src={backArrow} alt="Back" />
            </span>{' '}
          </h4>
        </div>

        <div className="col-lg-4">
          <div className="barOr">Stocked-in Successfully</div>
          <div className="ScanCar">
            <button className="goButton" onClick={scanNewAppointmentId}>
              Scan another Car
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};
export default BarCodeScanSuccess;
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
